// Constantes de texto e metadados da Jornada de Configuração.

// spec-002 — Classificação Obrigatório / Opcional. Copy PT-BR (acentuação real).
// Divisor inline entre etapas obrigatórias e opcionais no accordion do módulo.
export const DIVISOR_OPCIONAIS = 'Quando quiser ir além'
// ★ "Ir além" reúne DUAS coisas (2026-08-05): as opcionais do nível em exibição
// e as etapas dos níveis À FRENTE daquele módulo. Antes só as opcionais saíam
// aqui, e as etapas dos próximos níveis não apareciam em lugar nenhum até o
// escritório subir de nível — um módulo podia exibir "pronto para usar" com
// metade do conteúdo invisível. Cabeçalho de grupo é o sinal PRIMÁRIO de
// discriminação (não chip por linha: repetir a mesma tag em 6 linhas polui).
export const ALEM_GRUPO_OPCIONAIS = 'Opcionais deste nível'
// `{nivel}` = número, `{nome}` = nome do nível (NIVEIS), interpolados no consumidor.
export const ALEM_GRUPO_NIVEL = 'Nível {nivel} · {nome}'
export const ALEM_CONTAGEM_OPCIONAIS = '{n} opcionais'
export const ALEM_CONTAGEM_FUTURAS = '{n} de níveis à frente'
export const ALEM_CONTAGEM_MISTA = '{opcionais} opcionais · {futuras} de níveis à frente'
// Selo (BaseStatus) exibido quando todas as etapas obrigatórias estão concluídas.
export const SELO_PRONTO = 'Pronto para usar'
// Rótulo de progresso só-obrigatória do módulo. `{done}`/`{total}` interpolados no consumidor.
export const LABEL_OBRIGATORIAS = '{done} de {total} obrigatórias concluídas'

// ★ Etapa de funcionalidade NÃO contratada — a regra passou por três versões, e
// a de hoje é uma síntese das duas anteriores. Vale ler antes de mexer.
//
// **v1 — visível com selo "Não contratado".** A Jornada servia também de vitrine
// do produto. Escritório sem Asset Allocation via as 12 obrigatórias do módulo
// enfileiradas no Nível 1, empurrando para baixo o que ele de fato podia fazer.
//
// **v2 — escondida** (`filtrarModulosVisiveis`). Resolveu o ruído e criou um
// deadlock silencioso: o auto-avanço de nível é do BACKEND, que conta TODAS as
// obrigatórias e não conhece contrato (`nivel_esta_completo` exige
// `done >= total`). Escondendo, o front mostrava 100% e "Pronto para usar"
// enquanto o backend nunca promovia — e sumia junto a única saída que existia, o
// dot clicável, que na v1 permitia marcar a etapa e destravar o nível.
//
// **v3 (2026-08-05, achado CRITICAL do review do PR #1854) — depende do TIER:**
//
//   OBRIGATÓRIA → marcada `metadata.indisponivel`, fica no denominador, vai para
//                 o grupo colapsado "Não disponíveis no seu plano". A linha não
//                 abre (404), mas o dot continua clicável. Ruído resolvido pelo
//                 colapso; saída preservada pelo dot.
//   OPCIONAL    → continua sumindo. Nunca esteve no denominador, então não trava
//                 nada, e mantê-la seria só ruído.
//
// O caminho durável continua sendo o backend conhecer a funcionalidade por etapa
// (`metadata.funcionalidade`, curada no Interno) e ignorá-las na promoção — aí o
// front pode voltar a esconder tudo. Enquanto isso, ver `marcarIndisponiveis`
// (utils/progress.js) e INDISPONIVEL_SELO abaixo.

// ★ VITRINE — o terceiro estado, entre "contratada" e "escondida" (2026-08-05).
//
// A etapa que o catálogo marca com `metadata.premium_feature` NÃO é escondida
// quando falta a flag: fica visível, esmaecida e inerte. É a exceção deliberada à
// decisão acima, e o motivo é outro — ali o problema era uma trilha inteira de 12
// etapas não contratadas empurrando para baixo o que o escritório podia fazer;
// aqui são DUAS etapas dentro de um módulo que ele já tem, e o owner quer que
// elas sejam lidas ("deixa ele ler que existe").
//
// O que a mantém inofensiva — e o que faltava na tentativa anterior de manter
// etapa não contratada visível: ela sai de `isEssential`, então não entra no
// denominador do anel nem trava o auto-avanço de nível, e o dot fica DESABILITADO,
// então ninguém marca como concluída uma etapa que não pode executar.
export const VITRINE_SELO = 'Recurso adicional'
export const VITRINE_TOOLTIP =
  'Recurso adicional — fale com a AAWZ para habilitar no seu escritório.'
// Grupo próprio dentro de "ir além". `isEssential` já a tira do denominador; sem
// um grupo aqui ela voltaria para a lista principal por não ser opcional nem
// indisponível — foi o descompasso entre `essentialTasks` (filtrava só por
// `tier`) e `isEssential` (também exclui vitrine) que o review do PR #1854
// pegou: a etapa aparecia no topo e ficava fora da conta, e o card exibia 4
// linhas obrigatórias sob "X de 3 obrigatórias".
export const ALEM_GRUPO_VITRINES = 'Recursos adicionais'

// ★ INDISPONÍVEL — a obrigatória cuja TELA o escritório não contratou
// (2026-08-05, achado CRITICAL do review do PR #1854). Distinta da vitrine em
// dois pontos que importam:
//
//   vitrine       → fora do denominador, dot INERTE  (não há o que concluir)
//   indisponível  → NO denominador,     dot CLICÁVEL (é a saída para o nível)
//
// O dot clicável não é descuido: o auto-avanço de nível é do backend, que exige
// `done >= total` sobre TODAS as obrigatórias e não conhece contrato. Sem poder
// marcar, um escritório com Consolidador e sem Asset Allocation ficaria preso no
// Nível 1 para sempre. A linha, essa sim, não navega — a tela devolveria 404.
export const ALEM_GRUPO_INDISPONIVEIS = 'Não disponíveis no seu plano'
export const INDISPONIVEL_SELO = 'Fora do plano'
export const INDISPONIVEL_TOOLTIP =
  'Esta tela não está no plano do seu escritório. Marque como concluída para o ' +
  'nível avançar, ou fale com a AAWZ para contratar.'

// spec-004 — Níveis da Jornada. 4 níveis FIXOS (o backend nunca inventa um 5º:
// o CHECK da tabela restringe 1-4). `nivel` é dimensão ORTOGONAL ao tier: nível
// decide QUANDO um módulo/etapa entra na jornada visível; tier decide, dentro
// daquele nível, se é obrigatório. Sem classificação ⇒ Nível 1 (fail-open),
// mesma filosofia do tier ausente ⇒ obrigatório.
// ★ Nomenclatura de PROFICIÊNCIA (2026-07-29). Passou por
// Fundamental/Associado/Profissional → Iniciante/Pleno/Sênior → Básico/Intermediário/Avançado.
// A escala de senioridade de carreira foi abandonada porque lia como cargo da PESSOA;
// básico-intermediário-avançado descreve domínio da ferramenta, que é o que o nível mede.
// Os NÚMEROS (1-4) são o contrato com o backend e NÃO mudaram: renomear é troca de rótulo,
// nada em `escritorio_config_journey_nivel_atual` nem em `config_journey_perfil_item_nivel`
// é afetado. O Interno tem a própria lista (`NIVEL_OPTIONS` em JourneyProfiles.js) e as
// duas precisam andar juntas.
export const NIVEIS = [
  { nivel: 1, nome: 'Básico', descricao: 'O essencial para a plataforma funcionar.' },
  { nivel: 2, nome: 'Intermediário', descricao: 'Amplie o uso no dia a dia do escritório.' },
  { nivel: 3, nome: 'Avançado', descricao: 'Refine processos e ganhe eficiência.' },
  { nivel: 4, nome: 'Especialista', descricao: 'Explore todo o potencial da plataforma.' },
]

// Nível default quando o backend não devolve `nivel_atual` (fail-open — a
// gamificação nunca pode quebrar a Jornada; ver §fail-open do usecase de nível).
export const NIVEL_DEFAULT = 1

// Copy PT-BR do rail de níveis.
export const NIVEL_LABELS = {
  railTitulo: 'Jornada de configuração',
  // Sem troca manual (2026-07-29): o nível avança sozinho quando as obrigatórias
  // do nível atual são concluídas. O subtítulo não pode convidar a "escolher" —
  // o clique no hexágono só muda o que a listagem abaixo mostra.
  railSubtitulo:
    'Seu nível avança conforme você conclui as etapas obrigatórias. Clique num nível para ver o que ele reúne.',
  voceEstaAqui: 'Você está aqui',
  nivelPrefixo: 'Nível',
  nivelAtual: 'Nível atual',
  // Cabeçalho quando a listagem mostra um nível diferente do nível real do
  // escritório (usuário navegou pelo rail) — evita achar que já mudou de nível.
  visualizandoNivel: 'Visualizando',
  concluido: 'Concluído',
  progressoNivel: '{done} de {total} obrigatórias',
  // Nível sem nenhuma etapa obrigatória classificada. NÃO dizer "0 de 0
  // concluído": o nível não está pronto, está vazio — cenário comum quando o
  // perfil de curadoria só populou os primeiros níveis (ou não há perfil).
  // `progresso_por_nivel` do backend conta SÓ obrigatórias — um nível que tem
  // módulo mas só com etapas opcionais chega com total=0. Dizer "nenhuma etapa"
  // seria falso (o usuário vê o módulo logo abaixo); o correto é ser específico.
  semEtapas: 'Sem etapas obrigatórias',
  // ★ Rótulo acima do título no card da home (2026-07-29). Enquadra o que o nível mede:
  // "Básico" sozinho não diz básico em QUÊ. O rótulo vem ANTES do nome do nível, não
  // depois, porque quem bate o olho lê o enquadramento primeiro.
  homeRotulo: 'Seu domínio da plataforma',
  // Card compacto da HOME (resumo de uma linha) — `{nivel}` é o NOME do nível.
  // Encurtado de "Você está no nível X" para "Nível X": com o rótulo acima dando o
  // contexto, a frase longa virava redundância e roubava peso do percentual.
  homeTitulo: 'Nível {nivel}',
  concluidoMinusculo: 'concluído',
  proximoPasso: 'Próximo passo:',
  nivelSemPendencia: 'Tudo em dia neste nível.',
  // Nível 4 (último) concluído — a jornada acabou. Mensagem afirmativa em vez
  // de "tudo em dia", que soaria como mais uma pausa (decisão do usuário).
  especialistaTitulo: 'Você já é um especialista na plataforma',
  especialistaDetalhe: 'Concluiu todas as etapas obrigatórias dos 4 níveis.',
  // Nível atual concluído mas ainda há níveis à frente: convida a subir em vez
  // de só dizer que está em dia.
  sugestaoSubirNivel: 'Você concluiu este nível. Que tal avançar para o {proximo}?',
  verJornada: 'Ver jornada',
  // Nível sem NENHUMA etapa classificada nele (curadoria do Interno ainda não
  // distribuiu etapas por nível) — dizer isso é melhor que a seção sumir e o
  // usuário achar que a tela está quebrada.
  nivelSemEtapasDefinidas:
    'Nenhum módulo foi classificado neste nível ainda. A curadoria de níveis é feita pela AAWZ.',
  continuarJornada: 'Continuar jornada',
}

// spec-005 — Autoria da conclusão, exibida no drawer de detalhe de uma etapa
// concluída. `{autor}`/`{data}` são interpolados no consumidor (mesma convenção
// de LABEL_OBRIGATORIAS). Constante, não literal no template, para o teste
// assertar o texto sem duplicá-lo (convenção da linha 15).
// São DUAS constantes de propósito: `done_by` nasceu sem FK, então a autoria
// pode apontar para quem saiu do escritório e o backend devolve
// `concluida_por: null` sem erro. "Concluída por —" reabriria a pergunta sem
// respondê-la; omitir o trecho do autor responde o que dá (quando) e cala sobre
// o que não dá (quem). Sem copy condicional por persona nem rótulo de escopo.
export const AUTORIA = 'Concluída por {autor} em {data}'
export const AUTORIA_SEM_AUTOR = 'Concluída em {data}'

// Botão de voltar do guia. O destino depende de ONDE o guia foi aberto (ver
// utils/guide-origin.js): quem entrou pela barra de progresso dentro de um
// módulo volta para o módulo, não para a home da Jornada — onde ele nunca esteve.
//
// São QUATRO constantes e não duas porque header e rodapé já tinham frases
// distintas ("para a jornada" no ícone de voltar, "à jornada" no botão primário).
// Manter o par por origem preserva essa consistência; o rodapé fica curto porque
// é um BaseButton num painel de 380px — a frase longa quebra em duas linhas.
export const VOLTAR_JORNADA_HEADER = 'Voltar para a jornada'
export const VOLTAR_MODULO_HEADER = 'Voltar ao início do módulo'
export const VOLTAR_JORNADA_RODAPE = 'Voltar à jornada'
export const VOLTAR_MODULO_RODAPE = 'Voltar ao módulo'

// Barra de progresso da Jornada embutida na tela do módulo
// (components/central-config-module-progress-bar.vue).
export const BARRA_TITULO = 'Configuração do módulo'

// Ocultar/mostrar a barra (2026-08-21) — preferência por pessoa + módulo,
// persistida em localStorage (utils/module-bar-storage.js). Ocultar não apaga
// progresso nenhum, só a barra desta tela; "Mostrar" a traz de volta com os
// mesmos dados de sempre.
export const BARRA_OCULTAR = 'Ocultar barra de configuração do módulo'
export const BARRA_OCULTA_TEXTO = 'Jornada de configuração do módulo oculta'
export const BARRA_MOSTRAR = 'Mostrar'

// Subida de nível anunciada dentro do módulo. `{nivel}` é o NOME do nível
// (Básico/Intermediário/…), resolvido a partir de NIVEIS no consumidor.
// Fica numa linha do próprio card da barra — não é modal (interromperia quem
// está no meio de uma tarefa) nem toast (some antes de ser lido, e não volta).
export const NIVEL_SUBIU = 'Você chegou ao nível {nivel}'
export const NIVEL_SUBIU_DISPENSAR = 'Dispensar aviso de nível'

// Transição "Iniciar etapa" (2026-07-25) — GlobalBus. Emitido por
// router/index.js `afterEach` após navegação disparada por startTask() no
// accordion (clique direto na linha, sem modal intermediário); o drawer
// escuta pra mover o foco de teclado pra si (a11y: não perder o contexto
// após o redirect). Só o drawer escuta este evento.
export const CENTRAL_CONFIG_FOCUS_GUIDE = 'central_config_focus_guide'

// Canal do tour guiado: o balão de desfecho pediu para seguir à próxima etapa.
// Quem emite é a casca (central-config), quem escuta é o MÓDULO — só ele tem o
// mapa de seletores para montar os passos. Por isso o canal vive aqui e não no
// módulo: a casca não pode importar fee-fixo, e uma string literal dos dois
// lados divergiria em silêncio na primeira renomeação.
export const CENTRAL_CONFIG_TOUR_PROXIMA_ETAPA =
  'central_config_tour_proxima_etapa'
